import React, { useEffect, useState, useRef } from "react";
import { Container } from "./styles";
import Loading from "../loading";
import CustomButton from "../CustomButton/index.jsx";
import CheckBox from "../customInputs/CheckBox/index.jsx";
import searchIcon from "../../../assets/IconComponents/search.svg";

const WishList = ({ openList, wishlistData, wishlistFilter, setWishlistFilter, articleId, addNotification, openModal, closeModal, onAddWishlist, onAddToWishlist, onDeleteToWishlist }) => {
  const [filters, setFilters] = useState({ name: "" });
  const [lists, setLists] = useState([]);
  const [selectedLists, setSelectedLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const inputRef = useRef(null);

  useEffect(() => {
    if (wishlistData) {
      const selectedIds = wishlistData.map((list) => list.id);
      setSelectedLists(selectedIds);
    }
  }, [wishlistData]);

  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilters((prev) => ({ ...prev, name: value }));
  };


  const handleListSelection = (listId, listName) => {
    setSelectedLists((prevSelected) => {
      const isSelected = prevSelected.includes(listId);
      if (isSelected) {
        onDeleteToWishlist(articleId, listId, listName);
        return prevSelected.filter((id) => id !== listId);
      } else {
        onAddToWishlist(articleId, listId, listName);
        return [...prevSelected, listId];
      }
    });
  };
  

  const handleAdd = () => {
    openModal({
      className: "modal-add-wishlist",
      title: "Crear Wishlist",
      text: "Ingresa el nombre para tu wishlist",
      customComponent: <input className="input-wishlist" ref={inputRef} />,
      showAccept: false,
      showCancel: true,
      onCancelClick: closeModal,
      buttons: [
        {
          label: "Guardar",
          onClick: () => {
            const wishlistName = inputRef.current?.value || "";
            if (wishlistName.trim()) {
              onAddWishlist(wishlistName, addNotification);
            } else {
              addNotification("error", "El nombre de la wishlist no puede estar vacío");
            }
            closeModal();
          },
          className: "btn-guardar",
        },
      ],
    });
  };

  const filteredLists = wishlistFilter.filter((list) =>
    list.name.toLowerCase().includes(filters.name.toLowerCase())
  );

  return (
    <Container>
      <div className="search-bar">
        <img src={searchIcon} className="search-icon" alt="search icon" />
        <input
          type="text"
          className="search"
          onChange={handleFilterChange}
          value={filters.name}
          placeholder="Buscar wishlist"
        />
      </div>
      <div className="list-container">
        {filteredLists.map((list) => (
          <div key={list.id} className="list-item">
            <CheckBox
              id={list.id}
              checked={selectedLists.includes(list.id)}
              onChange={() => handleListSelection(list.id, list.name)}
              label={list.name}
            />
          </div>
        ))}
      </div>
      <div className="container-wish">
        <CustomButton
          className="create-wishlist"
          onClick={handleAdd}
          label="Crear WishList"
        />
      </div>
    </Container>
  );
};

export default WishList;
